import React, { useEffect, useState } from 'react';
import currentMeta from '../meta.json';

const UpdateNotifier = () => {
  const [showUpdate, setShowUpdate] = useState(false);
  const [changelog, setChangelog] = useState('');

  useEffect(() => {
    const checkVersion = async () => {
      try {
        const response = await fetch(`/meta.json?t=${new Date().getTime()}`, { cache: 'no-store' });
        if (!response.ok) return;
        const latestMeta = await response.json();
        if (latestMeta.version && currentMeta.version && latestMeta.version !== currentMeta.version) {
          if (latestMeta.changelog) setChangelog(latestMeta.changelog);
          setShowUpdate(true);
        }
      } catch (error) {
        console.error('Failed to check for updates', error);
      }
    };

    const initialCheck = setTimeout(checkVersion, 2000);
    const interval     = setInterval(checkVersion, 5 * 60 * 1000);
    const handleVisibilityChange = () => { if (document.visibilityState === 'visible') checkVersion(); };
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      clearTimeout(initialCheck);
      clearInterval(interval);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  if (!showUpdate) return null;

  return (
    <div
      className="fixed inset-0 z-[99999] flex items-end sm:items-center justify-center p-4 font-body"
      style={{ backgroundColor: 'rgba(0,0,0,0.5)', backdropFilter: 'blur(8px)' }}
      dir="rtl"
    >
      <div className="w-full max-w-sm bg-surface-container-lowest rounded-xl p-7 text-center shadow-[0px_24px_80px_rgba(0,0,0,0.25)]">

        {/* Icon */}
        <div className="w-16 h-16 mx-auto rounded-full bg-gradient-to-br from-primary to-primary-container flex items-center justify-center mb-5 shadow-lg shadow-primary/25">
          <span
            className="material-symbols-outlined text-white text-3xl"
            style={{ fontVariationSettings: "'FILL' 1" }}
          >
            system_update
          </span>
        </div>

        {/* Pulse dot */}
        <div className="flex items-center justify-center gap-2 mb-4">
          <span className="relative flex h-2.5 w-2.5">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary opacity-75" />
            <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-primary" />
          </span>
          <span className="text-xs font-bold uppercase tracking-widest text-primary">עדכון זמין</span>
        </div>

        <h2 className="text-2xl font-headline font-extrabold text-on-surface mb-2">
          גרסה חדשה זמינה! 🚀
        </h2>
        <p className="text-on-surface-variant text-sm leading-relaxed mb-1 whitespace-pre-wrap">
          {changelog || 'הוספנו שיפורים ואפשרויות חדשות לאפליקציה.'}
        </p>
        <p className="text-on-surface text-sm font-semibold leading-relaxed mb-7">
          לחץ על הכפתור כדי לטעון את הגרסה העדכנית.
        </p>

        <button
          onClick={() => window.location.reload(true)}
          className="w-full py-4 rounded-full font-label font-bold text-white text-base bg-gradient-to-r from-primary to-primary-container shadow-lg shadow-primary/25 hover:opacity-95 active:scale-95 transition-all"
        >
          רענן עכשיו ✓
        </button>

        <button
          onClick={() => setShowUpdate(false)}
          className="mt-3 w-full py-3 rounded-full font-label font-semibold text-on-surface-variant text-sm hover:bg-surface-container transition-colors"
        >
          אחר כך
        </button>

      </div>
    </div>
  );
};

export default UpdateNotifier;
